import type { CommandMessage } from '../types/commands.types';

/**
 * Returns a shallow clone of a CommandMessage with the `commandToken` field
 * removed from `data`.
 *
 * Use this before passing a command message to any logger, or before emitting
 * a message to consumers, so the per-session token is never written to log
 * output, forwarded to the orchestrator fragment's log command, or accessible
 * to component code.
 *
 * @param message - The command message to strip
 * @returns A new object with commandToken removed from data
 */
export function stripCommandToken(message: CommandMessage): CommandMessage {
  if (!message.data || typeof message.data !== 'object' || !('commandToken' in message.data)) {
    return message;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { commandToken: _token, ...rest } = message.data as unknown as Record<string, unknown>;
  return { ...message, data: rest } as CommandMessage;
}
